import React, { useEffect, useCallback } from "react";
import "./App.scss";
import { ConfigProvider, Layout } from "antd";
import { theme } from "../config/theme";
import { Route, Routes, Navigate } from "react-router-dom";
import { StandardLayout } from "../Layouts";
import {
  HomePage,
  PatientsListPage,
  About,
  Business,
  Privacy,
  Terms,
  ResetPassword,
  NotFoundPage,
  Profile,
} from "../pages";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../features/auth/authActions";

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);

  const setThemeCSSVariables = useCallback(() => {
    // Set colorPrimary as CSS variable
    if (theme?.token?.colorPrimary) {
      document.documentElement.style.setProperty(
        "--color-primary",
        theme?.token?.colorPrimary
      );
    }

    // Set colorSecondaryLogo as CSS variable
    if (theme?.token?.colorSecondaryLogo) {
      document.documentElement.style.setProperty(
        "--color-secondary-logo",
        theme?.token?.colorSecondaryLogo
      );
    }
  }, []);

  useEffect(() => {
    setThemeCSSVariables();
  }, [setThemeCSSVariables]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getMe());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <ConfigProvider theme={theme}>
      <Layout className="App-cont">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/patients" element={<PatientsListPage />} />
          <Route path="/login" element={<HomePage />} />
          <Route element={<StandardLayout />}>
            <Route path="/about" element={<About />} />
            <Route path="/business" element={<Business />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/" replace />} />
            <Route
              path="password-reset/:user_id/:token"
              element={<ResetPassword />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
